module.exports = __webpack_public_path__ + "img/csr4.c2283c70.jpg";